'use client';

import { FC } from 'react';
import { TextLink, Icon, IconNames } from '@petsmart-ui/sparky';
import { logoutUser } from '@libs/core';
import { trackNavigationHeaderClick } from '@libs/analytics';
import { navigationItems as defaultNavigationItems, NavigationItem } from './utils';

interface LoggedInNavListProps {
    /** Ref used for analytics tracking link base */
    linkRef: React.RefObject<string>;
    /** Clears cart on sign out */
    clearCart: () => void;
    /** Optional override for navigation items */
    items?: NavigationItem[];
}

export const LoggedInNavList: FC<LoggedInNavListProps> = ({
    linkRef,
    clearCart,
    items = defaultNavigationItems, // default to imported utils list
}) => {
    const handleLogout = async () => {
        await logoutUser('/sign-in', clearCart);
    };
    const handleClick = (isSignout: boolean, item: NavigationItem) => () => {
        if (!isSignout) {
            trackNavigationHeaderClick(item.trackingKey, `${linkRef.current}${item.url}`);
        }
    };
    return (
        <ul className="logged-in">
            {items.map(item => {
                const isSignout = item.trackingKey === 'signout';

                return (
                    <li className="logged-in__item" key={item.trackingKey}>
                        <TextLink
                            className="logged-in__link"
                            onClick={isSignout ? handleLogout : handleClick(isSignout, item)}
                            href={!isSignout ? item.url : undefined}
                        >
                            <Icon name={item.iconName as IconNames} />
                            {item.label}
                        </TextLink>
                    </li>
                );
            })}
        </ul>
    );
};
